export default __webpack_public_path__ + "static/media/pg.cac2e037.jpg";